import { gql } from '@apollo/client';

const query = gql`
  mutation UpdateReview($input: UpdateReviewInput!) {
    updateReview(input: $input) {
      review {
        id
        rating
        message
        displayName
        reviewState
      }
    }
  }
`;

module.exports = query;
